import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { translate } from 'i18n/i18n'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const alternaria: typeof valueTypeRenderers.alternaria = {
  label: () =>
    translate.phrases.templates('{{labelA}} ({{labelB}})', {
      labelA: translate.phrases.banyanApp('Alternaria'),
      labelB: translate.phrases.banyanApp('Daily DSV'),
    }),
  block: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.alternaria().title(),
      render: (v) => unitConverter.alternaria(v).valueAsString(),
    }),
}
